export default "__VITE_ASSET__DPT_On$C__"